export default __webpack_public_path__ + "static/news-img2-7b64a488cf2bc9bdafbf6e5dcbeb9086.jpg";